/* RESPONSIBLE TEAM: team-inbox */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import type Inbox from './inbox';
import { InboxCategory } from 'embercom/models/data/inbox/inbox-categories';
import { InboxType } from 'embercom/models/data/inbox/inbox-types';
import { NamedIcon } from '../command-k/icons';

export type CreatedByYouInboxWireFormat = {
  inbox_type: InboxType.CreatedByYou;
  count: number;
};

export default class CreatedByYou implements Inbox {
  readonly id = 'created_by_you';
  readonly category = InboxCategory.Shared;
  readonly type = InboxType.CreatedByYou;
  readonly count?: number;

  name = 'Created By You';

  readonly translationKey = 'inbox.inbox-list.created-by-you';

  icon = new NamedIcon('edit');

  constructor(count: number) {
    this.count = count;
  }

  static deserialize(json: CreatedByYouInboxWireFormat): CreatedByYou {
    return new CreatedByYou(json.count);
  }
}
